import React from 'react'

export default function Loader() {
  return (
      <img src="/images/yolokidz-official-logo-loading-10x.gif" alt="loading" width="448" height="96" />
  )
}
